import React, { Component } from 'react';
import { TextField } from 'rmwc/TextField';
import { Checkbox } from 'rmwc/Checkbox';
import { DateTimeRange } from "../components/DateTimeRange";
//import { Address } from "../components/Address";
import { ManageImage } from "../components/ManageImage";
import { MTextField } from "../components/MTextField";
import { MTextArea } from "../components/MTextArea";
import { MButton } from "../components/MButton";
import { getEvent, getImageSrc, saveEvent, generateImageName } from "../api/FirebaseAPI";
import "./EventForm.css"
//import update from 'immutability-helper';

export default class EventForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event:{
        title:"",
        startDate:"",
        published:false,
      },
      disabled:true,
      featureImageUrl:"",
      featureImageData:undefined,
      isLoading:true
    }
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  _id() {
    return this.props.computedMatch.params.id;
  }

  componentWillMount() {
    if (this._id()) {
      getEvent(this._id())
      .then((data) => {
        this.setState({
          event: data,
          isLoading:false
        });
        getImageSrc(data.featureImageStorageName)
        .then((url) => {
          if (url) {
            this.setState({featureImageUrl: url});
          }
        })
        .catch(err => {})
      })
    } else if (this.props.path === '/events/new') {
      this.setState({
        event:{},
        isLoading:false
      });
    }
  }

  handleDataChange(e) {
    const target = e.target;
    const id = target.id;
    const value = target.value;
    console.log("handleChange");
    console.log(id)
    console.log(value)
    this.setState({event:Object.assign(this.state.event, {[id]: value})})
  }

  handleToggle(e) {
    console.log(e)
    const target = e.target;
    const id = target.id;
    const value = target.checked;
    this.setState({event:Object.assign(this.state.event, {[id]: value})})
    console.log(id);
    console.log(value);
  }

  handleImageChange(imageData) {
    if (!this.state.event.featureImageStorageName) {
      const imageName = generateImageName();
      this.handleDataChange({target:{id:"featureImageStorageName", value:imageName}});
    }

    this.setState({featureImageData: imageData});
  }

  async handleSaveClick() {
    var result = await saveEvent(this._id(), this.state.event, this.state.featureImageData);
    if (!this._id()) {
      this.props.history.push(result + "/edit");
    }
  }

  renderAddress() {
    return (
      <div>
        <div>
          <MTextField id="venue" className="venue" label="Venue" value={this.state.event.venue} onChange={this.handleDataChange}/>
        </div>
        <div>
          <MTextField id="street" className="street" label="Street"  value={this.state.event.street} onChange={this.handleDataChange} />
        </div>
        <div>
          <MTextField id="locality" className="locality" label="Locality"  value={this.state.event.locality} onChange={this.handleDataChange} />
        </div>
        <div>
          <MTextField id="countrySubDivision" className="country-sub-division" label="State/Province"  value={this.state.event.countrySubDivision} onChange={this.handleDataChange} />
        </div>
      </div>
    )
  }

  renderDateTimeRange() {
    return (
      <DateTimeRange
        startDateTime={this.state.event.startDate}
        stopDateTime={this.state.event.stopDate}
        onChange={this.handleDataChange}
      />
    )
  }

  renderDescription() {
    return (
        <MTextArea
          id="description"
          className="description"
          label="Description"
          value={this.state.event.description}
          onChange={this.handleDataChange}
        />
    )
  }

  renderFacebookUrl() {
    return (
      <TextField
        id = 'facebookUrl'
        className = 'facebookUrl'
        label="Facebook"
        value={this.state.event.facebookUrl}
        onChange={this.handleDataChange}
      />
    )
  }

  renderHostedBy() {
    return (
      <TextField
        id = 'hostedBy'
        className = "hostedBy"
        label="Hosted By"
        value={this.state.event.hostedBy}
        onChange={this.handleDataChange}
      />
    )
  }

  renderManageImage() {
    return (
      <ManageImage
        id="featureImageStorageName"
        src={this.state.featureImageUrl}
        workingImageData={this.state.featureImageData}
        onChange={this.handleImageChange}
      />
    )
  }

  renderPublished() {
    return (
      <Checkbox
        id="published"
        checked={this.state.event.published}
        onChange={this.handleToggle}
      >Published
      </Checkbox>
    )
  }

  renderSave() {
    return (
      <MButton
        label="Save"
        onClick={this.handleSaveClick}
      />
    )
  }

  renderTicketUrl() {
    return (
      <MTextField
        id="ticketUrl"
        className="ticketUrl"
        label="Ticket URL"
        value={this.state.event.ticketUrl}
        onChange={this.handleDataChange}
      />
    )
  }

  renderTitle() {
    return (
        <MTextField
          id="title"
          className="title"
          label="Title"
          value={this.state.event.title}
          onChange={this.handleDataChange}
          required
        />
    )
  }

  render() {
    const state = this.state;
    return (
      (state.isLoading)
      ?<div>Loading</div>
      :
      <div className="event-form">
        <div>Event Form</div>
        <div>
          {this.renderSave()}
          {this.renderPublished()}
        </div>
        { /* Title */ }
        {this.renderTitle()}

        <div>
          {this.renderDateTimeRange()}
        </div>

        { /* Address */ }
        <div>
          {this.renderAddress()}
        </div>

        { /*Ticket*/ }
        <div>
          {this.renderTicketUrl()}
        </div>

        <div>
          {this.renderFacebookUrl()}
        </div>

        <div>
          {this.renderHostedBy()}
        </div>

        <div>
          {this.renderDescription()}
        </div>

        { /* Image */ }
        <div>
          {this.renderManageImage()}
        </div>
      </div>
    )
  }
}

/*
events/6KY9dLAngi960P79i5wi/edit
localhost:3000/events/6KY9dLAngi960P79i5wi/edit


http://localhost:3000/events/pKroVivhxDIl8jN69f91 LIVE DATA






*/



// WEBPACK FOOTER //
// ./src/containers/EventForm.js